import * as React from 'react';
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {
    changeContainerOfElement,
    changeDraggingElement,
    IChangeContainerPayload,
    IChangeDraggingElementPayload
} from "src/store/actions";
import {
    IAppState,
    IBoxes,
    IDraggingElement,
    IFruits,
    IShelves,
    IShelvesOrder,
    TActions
} from "src/store/models";
import {FruitShelfView} from "./FruitShelfView";

type TProps = IStateToProps & IDispatchToProps;

class AppView extends React.Component<TProps, {}> {
    public render() {
        const {
            shelvesOrder,
            boxes,
            fruits,
            shelves,
            mappedTrees,
            move,
            drag,
            draggingElement
        } = this.props;
        return mappedTrees === shelvesOrder.length ? (
            <div className="AppView">
                {shelvesOrder
                    .map(shelfId => (
                        <FruitShelfView
                            key={shelfId}
                            shelfId={shelfId}
                            draggingElement={draggingElement}
                            boxes={boxes}
                            fruits={fruits}
                            shelves={shelves}
                            move={move}
                            drag={drag}
                        />
                    ))
                }
            </div>
        ) : null;
    }
}

interface IStateToProps {
    boxes: IBoxes;
    draggingElement: IDraggingElement;
    fruits: IFruits;
    shelves: IShelves
    shelvesOrder: IShelvesOrder;
    mappedTrees: number;
}

interface IDispatchToProps {
    drag: (payload: IChangeDraggingElementPayload) => void;
    move: (payload: IChangeContainerPayload) => void;
}


export const mapStateToProps = (
    {
        shelves,
        shelvesOrder,
        boxes,
        fruits,
        mappedTrees,
        draggingElement
    }: IAppState
): IStateToProps => ({
    boxes,
    draggingElement,
    fruits,
    mappedTrees,
    shelves,
    shelvesOrder
});

export const mapDispatchToProps = (dispatch: Dispatch<TActions>): IDispatchToProps => ({
    drag: (payload: IChangeDraggingElementPayload) => dispatch(changeDraggingElement(payload)),
    move: (payload: IChangeContainerPayload) => dispatch(changeContainerOfElement(payload))
});

const connected = connect(mapStateToProps, mapDispatchToProps)(AppView);
export {connected as AppView};


// WEBPACK FOOTER //
// ./src/containers/view/AppView.tsx